// extracted by mini-css-extract-plugin
module.exports = {"starsContainer":"trustpilot_starsContainer__MWTT8"};